// src/redux/action/admin/services/type.js
export const SET_ALL_DATA_OF_ADMIN_SERVICES = "SET_ALL_DATA_OF_ADMIN_SERVICES";
export const SET_SERVICES_ADMIN_SERVICES = "SET_SERVICES_ADMIN_SERVICES";
export const SET_FILTERED_ADMIN_SERVICES = "SET_FILTERED_ADMIN_SERVICES";
export const SET_PAGES_DATA_ADMIN_SERVICES = "SET_PAGES_DATA_ADMIN_SERVICES";
export const RESET_ALL_ADMIN_SERVICES_DATA = "RESET_ALL_ADMIN_SERVICES_DATA";